import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Collapse, Container, Dialog, DialogContent, DialogTitle, DialogActions, FormControl, Grid, InputAdornment, IconButton, Fab, InputLabel, Paper, Select, TextField } from '@material-ui/core';
import Title from '../../../app/components/Title';
import { GridRowSelectedParams, GridCellValue } from '@material-ui/data-grid';
import LogsTable from '../../../app/components/datatables/LogsTable';
import { useData } from '../../../contexts/DataContext';
import CloseIcon from '@material-ui/icons/Close';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Add, HighlightOffOutlined } from '@material-ui/icons';
import { DateTimePicker } from "@material-ui/pickers";
import { useAuth } from '../../../contexts/AuthContext';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    img: {
        maxHeight: "100%",
        maxWidth: "100%",
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    fab: {
        position: 'absolute',
        bottom: theme.spacing(6),
        right: theme.spacing(4),
    },
}));

export default function AdminRainfallLog() {
    const classes = useStyles();

    const data = useData();
    const db = data?.db?.collection('Rainfall_data');
    const storage = data?.storage;
    const auth = useAuth();
    const [rainData, setRainData] = React.useState<any>([]);
    const [modalImage, setModalImage] = React.useState('');
    const [openImageModal, setOpenImageModal] = React.useState(false);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [updateModalOpen, setUpdateModalOpen] = React.useState(false);
    const [status, setStatus] = React.useState('');
    const [docId, setDocId] = React.useState('');
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteImageUrl, setDeleteImageUrl] = React.useState('');
    const [deleteDoc, setDeleteDoc] = React.useState('');
    const [openAlert, setOpenAlert] = React.useState(false);
    const [alertSuccess, setAlertSuccess] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState('');
    const [alertMessageTitle, setAlertMessageTitle] = React.useState('');
    const [latitude, setLatitude] = React.useState(0.0);
    const [longitude, setLongitude] = React.useState(0.0);
    const [address, setAddress] = React.useState('');
    const [rainfallReading, setRainfallReading] = React.useState(0.0);
    const [selectedDateTime, setSelectedDateTime] = React.useState(new Date());
    const [fileName, setFileName] = React.useState('');
    const [image, setImage] = React.useState<File>();
    const [watershedCode, setWatershedCode] = React.useState('');
    const [disableSubmit, setDisableSubmit] = React.useState(false);
    const [confirmationModal, setConfirmationModal] = React.useState(false);
    const [latError, setLatError] = React.useState(false);
    const [longError, setLongError] = React.useState(false);

    useEffect(() => {
        setRainData(data?.rainfallLogsData);
    }, [data?.rainfallLogsData])
    /*
        useEffect(() => {
            if (data?.gaugeData) {
                setGaugeData(data?.gaugeData);
                if (data?.gaugeData[0]) {
                    setLatitude(data?.gaugeData[0].Latitude);
                    setLongitude(data?.gaugeData[0].Longitude);
                    setAddress(data?.gaugeData[0].Address);
                    setWatershedCode(data?.gaugeData[0].WatershedCode);
                    setGaugeName(data?.gaugeData[0].Name);
                    setDisableFab(false);
                }
                else {
                    setDisableFab(true)
                    setAlert('No Rain Gauges', 'Please register a Rain Gauge', false);
                }
            }
            else {
                setDisableFab(true);
            }
        }, [data?.gaugeData])
    
        const updateGeoLocation = async () => {
            var promise = new Promise<boolean>(function (resolve, reject) {
                setTimeout(() => {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(async (position: any) => {
                            setLatitude(position.coords.latitude)
                            setLongitude(position.coords.longitude)
                            await getReverseGeocoding(position.coords.latitude, position.coords.longitude)
                            try {
                                const code = await fetchAreaCode('', position.coords.latitude, position.coords.longitude)
                                if (code.areaCode) {
                                    console.log(code)
                                    setWatershedCode(code.areaCode)
                                }
                            } catch (err) {
                                console.log(err);
                            }
                            resolve(true)
                        }, (err: any) => {
                            setAlert('GPS error', 'Please make sure that you have enabled GPS access.', false)
                            console.error(err)
                            setLatitude(0.0)
                            setLongitude(0.0)
                            reject(false)
                        });
                    } else {
                        setAlert('GPS error', 'Please make sure that you have enabled GPS access.', false)
                        reject(false)
                    }
                })
            })
            return promise
        }
    
        const getReverseGeocoding = async (lat = latitude, lon = longitude) => {
            if (lat === 0.0 || lon === 0.0)
                return 'Not Available'
            try {
                let response = await fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=AIzaSyA_hQEwXL0h9HaCPt8wDN3EuFvEw3IE-s8');
                const data = await response.json();
                const address = data?.results[2]?.formatted_address
                if (address)
                    setAddress(address)
                return address
            } catch (err) {
                console.error(err);
                return 'Not Available'
            }
        }
    */
    const handleUpdateStatus = async (e: any) => {
        e.preventDefault();
        const statusValue = parseInt(status);
        try {
            await db?.doc(docId).update({
                "Status": statusValue
            });
            setAlert('Success', 'Status Updated')
        }
        catch {
            setAlert('Error', "Couldn't Update", false);
        }
        handleUpdateModalClose();
    }

    const deleteData = async () => {
        try {
            if (deleteImageUrl) {
                if (storage) {
                    let imageRef = storage.refFromURL(deleteImageUrl);
                    imageRef.delete();
                    setAlert('Deleted', "Row Deleted Successfully");
                }
            }
            if (deleteDoc) {
                await db?.doc(deleteDoc).delete();
            }
        }
        catch {
            setAlert('Error', "Couldn't Delete Row", false);
        }
        deleteModalClose();
    }

    const handleTableClick = (DocImageUrl: GridCellValue) => {
        const imageUrl = DocImageUrl?.toLocaleString();
        if (imageUrl) {
            setModalImage(imageUrl);
            setOpenImageModal(true);
        }
    }

    const handleTableClickClose = () => {
        setOpenImageModal(false);
    }

    const handleModalClick = (params: GridRowSelectedParams) => {
        if (params.data.Status) {
            setStatus(params.data.Status.toLocaleString());
        }
        if (params.data.docId) {
            setDocId(params.data.docId.toLocaleString());
        }
        setUpdateModalOpen(true);
    }

    const handleUpdateModalClose = () => {
        setUpdateModalOpen(false);
    }

    const deleteModalOpen = (docId: GridCellValue, docImageUrl: GridCellValue) => {
        const id = docId?.toLocaleString();
        const imageUrl = docImageUrl?.toLocaleString();
        if (id)
            setDeleteDoc(id);
        if (imageUrl)
            setDeleteImageUrl(imageUrl);
        setDeleteModal(true);
    }

    const deleteModalClose = () => {
        setDeleteModal(false);
    }

    const setAlert = (title: string, message: string, success = true) => {
        setAlertSuccess(success);
        setAlertMessage(message);
        setAlertMessageTitle(title);
        setOpenAlert(true);
    }

    const addData = async () => {
        setDisableSubmit(true)
        //updateLocation();
        var Url = '';

        /*Upload image, if available*/
        try {
            if (storage) {
                if (image) {
                    const upload = await storage.ref('images/' + image.name).put(image);
                    if (upload) {
                        Url = await storage.ref('images').child(image.name).getDownloadURL();
                    }
                    else {
                        setAlert('Error', 'Image cannot be uploaded. Please try again.', false)
                        handleModalClose();
                        return;
                    }
                }
            } else {
                setAlert('Error', 'Image cannot be uploaded. Try again later!', false)
                handleModalClose();
                return;
            }
        }
        catch {
            setAlert('Error', 'Something went wrong!', false)
            handleModalClose();
            return;
        }

        try {
            const response = await db?.add({
                "Latitude": latitude,
                "Longitude": longitude,
                "Name": auth?.currentUser?.displayName,
                "Address": address,
                "WatershedCode": watershedCode,
                "Reading": Number(rainfallReading).toFixed(2),
                "DateTime": selectedDateTime.getTime(),
                "Image": Url,
                "uid": auth?.currentUser?.uid,
                "timestamp": new Date().getTime(),
                "Status": 0,// (0)Pending | (1)Approved | (2)Rejected
            })
            if (response) {
                setAlert("Success!", 'Successfully logged data')
            }
            else {
                setAlert('Error', "Couldn't log data. Please try again.", false)
            }
        }
        catch {
            setAlert('Error', "Couldn't log data. Try again later!", false)
        }
        handleModalClose();
    }

    const handleClickAddButton = async () => {
        setModalOpen(true)
    }

    const handleModalClose = () => {
        setModalOpen(false)
        setAddress('');
        setWatershedCode('');
        setLatitude(0);
        setLongitude(0);
        setLatError(false);
        setLongError(false);
        setRainfallReading(0.0)
        setDisableSubmit(false)
        clearUploadedFile()
    };

    const clearUploadedFile = () => {
        setFileName('')
        setImage(undefined)
    }

    return <>
        <Collapse in={openAlert}>
            <Alert
                severity={alertSuccess ? "success" : "error"}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            setOpenAlert(false);
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
            >
                <AlertTitle>{alertMessageTitle}</AlertTitle>
                {alertMessage}
            </Alert>
        </Collapse>
        <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Title>Rainfall Data</Title>
                        <LogsTable data={rainData} onImageDeleteClick={handleTableClick} onCellDeleteClick={deleteModalOpen} onRowSelected={handleModalClick} admin={true} />
                    </Paper>
                </Grid>
            </Grid>
        </Container>
        <Fab className={classes.fab} color="primary" aria-label="add" onClick={handleClickAddButton}>
            <Add />
        </Fab>
        <div>
            <Dialog fullWidth open={modalOpen} onClose={handleModalClose} aria-labelledby="form-dialog-title" >
                <DialogTitle id="form-dialog-title">
                    Log Rainfall Data
                    <Button variant="text" style={{ float: 'right', padding: 0 }} onClick={handleModalClose}>
                        <HighlightOffOutlined />
                    </Button>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                error={latError}
                                autoFocus
                                margin="dense"
                                id="latitude"
                                label="Latitude"
                                value={latitude}
                                onChange={(e: any) => {
                                    (/^[0-9]+(\.[0-9]+)?$/).test(e.target.value) ? setLatError(false) : setLatError(true);
                                    setLatitude(e.target.value);
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                error={longError}
                                autoFocus
                                margin="dense"
                                id="longitude"
                                label="Longitude"
                                value={longitude}
                                onChange={(e: any) => {
                                    (/^[0-9]+(\.[0-9]+)?$/).test(e.target.value) ? setLongError(false) : setLongError(true);
                                    setLongitude(e.target.value);
                                }}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="address"
                        label="Address"
                        value={address}
                        onChange={(e: any) => {
                            setAddress(e.target.value);
                        }}
                        fullWidth
                    />
                </DialogContent>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="waterShedCode"
                        label="Watershed Code"
                        value={watershedCode}
                        onChange={(e: any) => {
                            setWatershedCode(e.target.value);
                        }}
                        fullWidth
                    />
                </DialogContent>
                <DialogContent>
                    <DateTimePicker
                        label="Time of measurement"
                        inputVariant="outlined"
                        value={selectedDateTime}
                        onChange={(e: any) => setSelectedDateTime(e)}
                        fullWidth
                        disabled={!auth?.currentUserTrusted}
                    />
                </DialogContent>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="measurement"
                        label="Rainfall Measurement"
                        type="number"
                        inputProps={{ style: { textAlign: 'center' } }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                        }}
                        value={rainfallReading}
                        onChange={(e: any) => {
                            const { value } = e.target;
                            var validNumber = new RegExp(/^\d*\.?\d*$/);
                            var lastValid = rainfallReading;
                            if (validNumber.test(value))
                                lastValid = value;
                            setRainfallReading(lastValid);
                        }}
                        fullWidth
                    />
                </DialogContent>
                <DialogContent>
                    <Button
                        variant="outlined"
                        component="label"
                        color="primary"
                    >
                        Add photo
                        <input
                            accept="image/*"
                            type="file"
                            hidden
                            onChange={(e: any) => {
                                const newFile = new File([e.target.files[0]], `${auth?.currentUser?.uid}_${new Date().getTime()}`, { type: e.target.files[0].type })
                                setFileName(e.target.files[0].name);
                                setImage(newFile);
                            }}
                            required
                        />
                    </Button> {fileName}
                    {fileName && <IconButton
                        aria-label="delete"
                        color="inherit"
                        onClick={() => {
                            clearUploadedFile()
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>}
                </DialogContent>
                {!auth?.currentUserTrusted && <Alert severity="info">Kindly note : <br />
                    1. Please log the measurement from the actual location of your rainguage.<br />
                    2. Please log the measurement in real time.<br />
                    3. Please add a photo of your rainguage showing the measurement you entered.</Alert>}
                <DialogActions>
                    <Button onClick={handleModalClose} variant="outlined" color="default">
                        Cancel
                    </Button>
                    <Button onClick={() => { (rainfallReading > 0) ? addData() : setConfirmationModal(true) }} variant="contained" color="primary" disabled={(!auth?.currentUserTrusted && !image) || disableSubmit || !watershedCode}>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
        <div>
            <Dialog open={openImageModal} onClose={handleTableClickClose} aria-labelledby="form-dialog-title">
                <DialogContent>
                    <img className={classes.img} src={modalImage} alt={"DataImage"} />
                </DialogContent>
            </Dialog>
        </div>
        <div>
            <Dialog open={updateModalOpen} onClose={handleUpdateModalClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Update Status</DialogTitle>
                <DialogContent>
                    <form className={classes.form} noValidate>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl>
                                    <InputLabel htmlFor="set-status">Status</InputLabel>
                                    <Select
                                        native
                                        value={status}
                                        inputProps={{
                                            name: 'Status',
                                            id: 'set-status',
                                        }}
                                        onChange={e => setStatus(e.target.value as string || '')}
                                        fullWidth
                                    >
                                        <option value='0'>Pending</option>
                                        <option value='1'>Approved</option>
                                        <option value='2'>Rejected</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={handleUpdateStatus}
                        >
                            Update
                        </Button>
                    </form>
                </DialogContent>
            </Dialog>
        </div>
        <div>
            <Dialog open={deleteModal} onClose={deleteModalClose} aria-labelledby="form-dialog-title">
                <DialogContent>
                    Are you sure you want to delete this data?
                </DialogContent>
                <DialogActions>
                    <Button onClick={deleteModalClose} variant="contained" color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={deleteData} variant="contained" color="primary">
                        Delete
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
        <div>
            <Dialog open={confirmationModal} onClose={() => { setConfirmationModal(false) }} aria-labelledby="form-dialog-title">
                <DialogContent>
                    Are you sure you want to log 'No Rainfall' in the last 24 hours?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setConfirmationModal(false) }} variant="contained" color="secondary">
                        No
                    </Button>
                    <Button onClick={() => { setRainfallReading(0); addData(); setConfirmationModal(false) }} variant="contained" color="primary">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    </>
}